import { render } from "./StartToday.vue?vue&type=template&id=2109bb25&scoped=true"
import script from "./StartToday.vue?vue&type=script&lang=js"
export * from "./StartToday.vue?vue&type=script&lang=js"

import "./StartToday.vue?vue&type=style&index=0&id=2109bb25&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2109bb25"]])

export default __exports__